export default __webpack_public_path__ + "static/screenshot_1d-d8e3cff1f57946d3a05c04ebaf2b518c.png";